export default[
    {
        path:`/funcionario/:hash/:id`,
        name:"funcionario",
        component: () =>
        import(/* webpackChunkName: "funcionario" */ "../funcionarioInfo.vue"),
    }
]